"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeTypographyStyles = void 0;

var makeTypographyStyles = function makeTypographyStyles(_ref) {
  var tokens = _ref.tokens;
  return {
    MuiTypography: {
      styleOverrides: {
        root: {
          color: tokens.colors["text-on-background"].color
        },
        colorPrimary: {
          color: tokens.colors["text-on-background"].color
        },
        colorError: {
          color: tokens.colors["ink-error"].color
        }
      }
    }
  };
};

exports.makeTypographyStyles = makeTypographyStyles;